import { render, staticRenderFns } from "./custIndustryReport.vue?vue&type=template&id=5f36f193&scoped=true&"
import script from "./custIndustryReport.vue?vue&type=script&lang=js&"
export * from "./custIndustryReport.vue?vue&type=script&lang=js&"
import style0 from "./custIndustryReport.vue?vue&type=style&index=0&id=5f36f193&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36f193",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f36f193')) {
      api.createRecord('5f36f193', component.options)
    } else {
      api.reload('5f36f193', component.options)
    }
    module.hot.accept("./custIndustryReport.vue?vue&type=template&id=5f36f193&scoped=true&", function () {
      api.rerender('5f36f193', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/report/custIndustryReport/custIndustryReport.vue"
export default component.exports